<template>
  <vue-content-loading :width="300" :height="$vuetify.breakpoint.smAndDown ? 250 : 150">
    <rect
      :x="105"
      :y="0"
      :rx="2"
      :ry="2"
      :height="10"
      :width="90" />

    <rect
      :x="62"
      :y="15"
      :rx="2"
      :ry="2"
      :height="5"
      :width="176" />

    <rect
      v-for="(inputRow, index) in inputRows"
      :key="`inputRow_${index}`"
      v-bind="inputRow"/>

    <rect
      v-for="(labelRow, index) in labelRows"
      :key="`labelRow_${index}`"
      v-bind="labelRow"/>
  </vue-content-loading>
</template>

<script>
import VueContentLoading from 'vue-content-loading';

export default {
  components: {
    VueContentLoading,
  },
  data() {
    return {
      inputRowCount: 5,
    };
  },
  computed: {
    inputRows() {
      const output = [];
      let rowCount = 0;

      for (let i = 0; i < this.inputRowCount; i += 1) {
        const inputDimensions = {
          x: i % 2 && i > 0 ? 154 : 18,
          y: (rowCount * 30) + 52,
          rx: 2,
          ry: 2,
          height: 10,
          width: 128,
        };

        if (this.$vuetify.breakpoint.smAndDown) {
          inputDimensions.x = 42;
          inputDimensions.y = (i * 45) + 60;
          inputDimensions.height = 20;
          inputDimensions.width = 220;
        }

        output.push(inputDimensions);
        if (i % 2 && i > 0) {
          rowCount += 1;
        }
      }
      return output;
    },
    labelRows() {
      const output = [];
      let rowCount = 0;

      for (let i = 0; i < this.inputRowCount; i += 1) {
        const labelDimensions = {
          x: i % 2 && i > 0 ? 154 : 18,
          y: (rowCount * 30) + 45,
          rx: 2,
          ry: 2,
          height: 5,
          width: 50,
        };

        if (this.$vuetify.breakpoint.smAndDown) {
          labelDimensions.x = 42;
          labelDimensions.y = (i * 45) + 45;
          labelDimensions.height = 10;
        }

        output.push(labelDimensions);
        if (i % 2 && i > 0) {
          rowCount += 1;
        }
      }
      return output;
    },
  },
};
</script>
